import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import {
  setLoadingCustomers,
  setLoadingCustomer,
  setLoadingCustomerCreate,
  setLoadingCustomerUpdate,
  setLoadingCustomerDelete,
  setErrorLoadingCustomers,
  setErrorLoadingCustomer,
  setErrorCreatingCustomer,
  setErrorUpdatingCustomer,
  setErrorDeletingCustomer,
  setCustomers,
  setCustomer,
  createCustomerSuccess,
  updateCustomerSuccess,
  deleteCustomerSuccess,
  setServerResponseStatus,
  setPagination,
} from "../slices/customer";
import { getErrorMessage } from "../../utils/errorUtils";

export const getCustomers =
  ({ page = 1, size = 10, search = "" }) =>
  async (dispatch) => {
    dispatch(setLoadingCustomers());

    try {
      const params = {
        page,
        size,
      };

      // Only add optional params if they have values
      if (search) params.search = search;
      const { data } = await axiosInstance.get("/customers", {
        headers: { requiresAuth: true },
        params,
      });

      if (data.status === "SUCCESS") {
        dispatch(setCustomers(data.data.content));
        dispatch(setPagination(data.data.pagination));
      }
    } catch (error) {
      dispatch(setErrorLoadingCustomers(getErrorMessage(error)));
    }
  };

export const getCustomerById = (id) => async (dispatch) => {
  dispatch(setLoadingCustomer());

  try {
    const { data } = await axiosInstance.get(`/customers/${id}`, {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      dispatch(setCustomer(data.data));
    }
  } catch (error) {
    dispatch(setErrorLoadingCustomer(getErrorMessage(error)));
  }
};

export const createCustomer = (values) => async (dispatch) => {
  dispatch(setLoadingCustomerCreate());

  try {
    const { data } = await axiosInstance.post("/customers", values, {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      toast.success(data.message || "Customer created successfully!");
      dispatch(createCustomerSuccess(data.data));
      dispatch(
        setServerResponseStatus({
          operation: "create",
          status: data.statusCode,
        }),
      );
    }
  } catch (error) {
    const message = getErrorMessage(error);
    toast.error(message);
    dispatch(setErrorCreatingCustomer(message));
  }
};

export const updateCustomer =
  ({ id, values }) =>
  async (dispatch) => {
    dispatch(setLoadingCustomerUpdate());

    try {
      const { data } = await axiosInstance.put(`/customers/${id}`, values, {
        headers: { requiresAuth: true },
      });

      if (data.status === "SUCCESS") {
        toast.success(data.message || "Customer updated successfully!");
        dispatch(updateCustomerSuccess(data.data));
        dispatch(
          setServerResponseStatus({
            operation: "update",
            status: data.statusCode,
          }),
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(setErrorUpdatingCustomer(message));
    }
  };

export const deleteCustomer = (id) => async (dispatch) => {
  dispatch(setLoadingCustomerDelete());

  try {
    const { data } = await axiosInstance.delete(`/customers/${id}`, {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      toast.success(data.message || "Customer deleted successfully!");
      dispatch(deleteCustomerSuccess(id));
      dispatch(
        setServerResponseStatus({
          operation: "delete",
          status: data.statusCode,
        }),
      );
    }
  } catch (error) {
    const message = getErrorMessage(error);
    toast.error(message);
    dispatch(setErrorDeletingCustomer(message));
  }
};

export const resetCustomerServerStatus = () => (dispatch) => {
  dispatch(setServerResponseStatus(null));
};
